import { Link, useLocation } from 'react-router';
import { useCallback } from 'react';
import { NAV_PATH, ROUTER_PATH } from '@/router/constants';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import { Autoplay } from 'swiper/modules';

const images = {
	banner0: require('@/assets/images/img_header_banner0.png'),
	banner1: require('@/assets/images/img_header_banner1.png'),
	banner2: require('@/assets/images/img_header_banner2.png'),
	banner3: require('@/assets/images/img_header_banner3.png'),
	banner4: require('@/assets/images/img_header_banner4.png'),
	banner5: require('@/assets/images/img_header_banner5.png'),
	banner6: require('@/assets/images/img_header_banner6.png')
};
const banner = [
	{
		src: images.banner5,
		link: `${NAV_PATH.FUNCTION.CONVENIENCE}#${'offsetmanagement'}`,
		alt: '[주요공지] 매출채권/매입채무 관리를 위한 반제관리 기능 추가!'
	},
	{
		src: images.banner6,
		link: `${NAV_PATH.CONSULTING}`,
		alt: '[주요공지] 국내 최고 전문가팀과 함께하는 전문가문의 기능 추가'
	},
	{
		src: images.banner4,
		link: `${NAV_PATH.FUNCTION.MAIN}#${'b2b'}`,
		alt: '[OPEN] 기업 간 거래를 위한 B2B 서비스 출시!'
	},
	{
		src: images.banner0,
		alt: '[업데이트] MAC OS에서도 모든 기능을 자유롭게!'
	},
	{
		src: images.banner1,
		link: `${NAV_PATH.FUNCTION.MAIN}#${'accountancy'}`,
		alt: '[주요공지]  편리한 외화거래를 위한 외화관리 기능 오픈!'
	},
	{
		src: images.banner2,
		link: `${NAV_PATH.FUNCTION.CONVENIENCE}#${'community'}`,
		alt: '[주요공지] 세무대리인과 수임처를 위한 소통함 오픈!'
	},
	{
		src: images.banner3,
		link: `${NAV_PATH.FUNCTION.CONVENIENCE}#${'costprofit'}`,
		alt: '[주요공지] 기간비용/수익관리 오픈, 나눠서 자동 관리 가능 !'
	}
];

const HeaderGroup = () => {
	// Active 클래스 추가 로직
	const { pathname } = useLocation();
	const isActive = useCallback(
		(path: string | string[]) => {
			if (typeof path === 'string') {
				if (pathname.includes(path)) {
					return 'active';
				} else {
					return '';
				}
			} else {
				const isActive = path.some(p => pathname.includes(p));
				return isActive ? 'active' : '';
			}
		},
		[pathname]
	);

	return (
		<>
			<div className="header-banner">
				<Swiper
					direction="vertical"
					slidesPerView={1}
					loop
					autoplay={{
						delay: 5000,
						speed: 5000
					}}
					modules={[Autoplay]}>
					{banner.map((slide, index) => (
						<SwiperSlide key={index}>
							<a href={slide.link}>
								<img src={slide.src} alt={slide.alt} />
							</a>
						</SwiperSlide>
					))}
				</Swiper>
			</div>
			<div className="header-group">
				<div className="header-inner">
					<h1 className="logo-wrap">
						<Link className="logo" to="/" title="Stella logo" aria-hidden="true">
							<span className="blind">홈으로</span>
						</Link>
					</h1>
					<nav id="" className="gnb-wrap">
						<ul className="gnb">
							<li className={`depth1 ${isActive(NAV_PATH.INTRO)}`}>
								<Link to={NAV_PATH.INTRO}>서비스 소개</Link>
							</li>
							<li className={`depth1 ${isActive(Object.values(ROUTER_PATH.FUNCTION))}`}>
								<Link to={NAV_PATH.FUNCTION.MAIN} className="new">
									특별한 기능
								</Link>
								<ul>
									<li className={`depth2 ${isActive(NAV_PATH.FUNCTION.MAIN)}`}>
										<Link to={NAV_PATH.FUNCTION.MAIN}>주요 기능</Link>
									</li>
									<li className={`depth2 ${isActive(NAV_PATH.FUNCTION.CONVENIENCE)}`}>
										<Link to={NAV_PATH.FUNCTION.CONVENIENCE}>편의 기능</Link>
									</li>
								</ul>
							</li>
							<li className={`depth1 ${isActive(NAV_PATH.PRICE)}`}>
								<Link to={NAV_PATH.PRICE}>가격 정책</Link>
							</li>
							<li className={`depth1 ${isActive(NAV_PATH.CONSULTING)}`}>
								<Link to={NAV_PATH.CONSULTING}>전문가문의</Link>
							</li>
							<li className={`depth1 ${isActive(Object.values(ROUTER_PATH.CUSTOMER_SUPPORT))}`}>
								<Link to={NAV_PATH.CUSTOMER_SUPPORT.FAQ}>고객 지원</Link>
								<ul>
									<li className={`depth2 ${isActive(NAV_PATH.CUSTOMER_SUPPORT.FAQ)}`}>
										<Link to={NAV_PATH.CUSTOMER_SUPPORT.FAQ}>자주 묻는 질문</Link>
									</li>
									{/* <li className={`depth2 ${isActive(NAV_PATH.CUSTOMER_SUPPORT.EVENT)}`}>
									<Link to={NAV_PATH.CUSTOMER_SUPPORT.EVENT}>이벤트</Link>
								</li> */}
								</ul>
							</li>
							<li className={`depth1 ${isActive(Object.values(ROUTER_PATH.INQUIRY))}`}>
								<Link to={NAV_PATH.INQUIRY.SERVICE}>문의하기</Link>
								<ul>
									<li className={`depth2 ${isActive(NAV_PATH.INQUIRY.SERVICE)}`}>
										<Link to={NAV_PATH.INQUIRY.SERVICE}>서비스 문의</Link>
									</li>
									<li className={`depth2 ${isActive(NAV_PATH.INQUIRY.PARTNERSHIP)}`}>
										<Link to={NAV_PATH.INQUIRY.PARTNERSHIP}>제휴 문의</Link>
									</li>
								</ul>
							</li>
						</ul>
					</nav>
					<a
						href="http://www.stella-erp.com"
						className="btn primary round md"
						rel="noopener noreferrer"
						target="_blank"
						title="새창 열림">
						스텔라 서비스 바로가기
					</a>
				</div>
			</div>
		</>
	);
};

export default HeaderGroup;
